import { useLazyQuery }              from '@apollo/client'
import { useEffect, useState }       from 'react'
import { useSelector }               from 'react-redux'
import { useParams }                 from 'react-router-dom'
import { LoadingEllipsis }           from '../../../components/Loaders'
import SettingsShopSizeGuideForm     from '../../../components/Settings/ShopSettings/SettingsShopSizeGuideForm'
import { GET_SHOP_SIZE_GUIDE_BY_ID } from '../../../graphql/shop'
import MainLayout                    from '../../../layouts/MainLayout'

export default function SettingsShopSizeGuide(): JSX.Element {
  const { size_guide_id }           = useParams()
  const currentUser: any            = useSelector( ( state: any ): any => state.currentUser.user )
  const [ sizeGuide, setSizeGuide ] = useState( null )

  const [ getSizeGuide, { loading, refetch } ] = useLazyQuery( GET_SHOP_SIZE_GUIDE_BY_ID, {
    onCompleted: ( { shopSizeGuideById }: any ): void => setSizeGuide( shopSizeGuideById )
  } )

  const fetchSizeGuide: any = async (): Promise<void> => {
    await getSizeGuide( { variables: { input: { id: size_guide_id } } } )
  }

  useEffect( (): any => {
    let shouldFetch: boolean = true

    if ( shouldFetch && size_guide_id ) {
      fetchSizeGuide()
    }

    return (): void => {
      shouldFetch = false
    }
  }, [ size_guide_id ] )

  return (
    <MainLayout>
      <div className="max-w-screen-3xl mx-auto w-full">
        <div className="flex-grow lg:p-8 p-3 space-y-4 lg:space-y-8">
          { ( loading || !currentUser ) && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4 mt-4 w-full" /> }
          { !loading && currentUser?.admin &&
            <>
              { sizeGuide &&
                <SettingsShopSizeGuideForm sizeGuide={ sizeGuide } refetch={ refetch } />
              }
              { !sizeGuide &&
                <SettingsShopSizeGuideForm />
              }
            </>
          }
          { !currentUser?.admin &&
            <div className="row flex flex-col items-center w-full bg-white rounded-3xl p-3 xl:p-4">
              Access Denied!
            </div>
          }
        </div>
      </div>
    </MainLayout>
  )
}
